
<div [className]="isBGClass == true ? 'loader-overlay' : ''">
  <ngx-ui-loader
  [fgsColor]="ngxuiloaderconfiguration.fgsColor"
  [fgsPosition]="ngxuiloaderconfiguration.fgsPosition"
  [fgsSize]="ngxuiloaderconfiguration.fgsSize"
  [fgsType]="ngxuiloaderconfiguration.fgsType"
  [bgsColor]="ngxuiloaderconfiguration.bgsColor"
  [bgsOpacity]="ngxuiloaderconfiguration.bgsOpacity"
  [bgsPosition]="ngxuiloaderconfiguration.bgsPosition"
  [bgsSize]="ngxuiloaderconfiguration.bgsSize"
  [bgsType]="ngxuiloaderconfiguration.bgsType"
  [gap]="ngxuiloaderconfiguration.gap"
  [logoPosition]="ngxuiloaderconfiguration.logoPosition"
  [logoSize]="ngxuiloaderconfiguration.logoSize"
  [logoUrl]="ngxuiloaderconfiguration.logoUrl"
  [overlayColor]="ngxuiloaderconfiguration.overlayColor"
  [pbColor]="ngxuiloaderconfiguration.pbColor"
  [pbDirection]="ngxuiloaderconfiguration.pbDirection"
  [pbThickness]="ngxuiloaderconfiguration.pbThickness"
  [hasProgressBar]="ngxuiloaderconfiguration.hasProgressBar"
  [text]="ngxuiloaderconfiguration.text"
  [textColor]="ngxuiloaderconfiguration.textColor"
  [textPosition]="ngxuiloaderconfiguration.textPosition"
></ngx-ui-loader>
</div>
